import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Loadingcontainer from './loadingcontainer';
import { updateAppState } from '../actions/actions';

class CustomerSupport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loaderflag : true
		};
		
		this.listbodyRef = this.listbodyRef.bind(this);
		
	}

	componentDidMount() {
		this.setState({
			loaderflag : false
		});
	}

	listbodyRef(node) {
		if(node) {
			node.addEventListener('scroll', (evt) => {
				this.refs.listheader.scrollLeft = evt.srcElement.scrollLeft;
			});
		}
	}

	render() {
		
		
		let { loaderflag } = this.state;

		let table_body_height = $(window).outerHeight() - $('.header').outerHeight() -$('.page_title').outerHeight() - 60;

		let customersupportsrc = '';
		if(this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch)) customersupportsrc = './images/customer_support.png';
		//if(this.props.app.companyid == 1 && this.props.app.branch == 'Jharkhand') customersupportsrc = './images/customer_support_jharkhand.png';
		//if(this.props.app.companyid == 1 && this.props.app.branch == 'Arunachal Pradesh') customersupportsrc = './images/customer_support_arunachalpradesh.png';
		//if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura') customersupportsrc = './images/customer_support_tripura.png';
		//if(this.props.app.companyid == 1 && this.props.app.branch == 'Tripura New') customersupportsrc = './images/customer_support_tripura.png';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Mizoram') customersupportsrc = './images/customer_support_mizoram.png';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Nagaland') customersupportsrc = './images/customer_support_nagaland.png';
		if(this.props.app.companyid == 1 && this.props.app.branch == 'Sysmex') customersupportsrc = './images/customer_support_sysmex.png';
		//if(this.props.app.companyid == 3 && this.props.app.companydetails.name ==  'Government of Jammu & Kashmir') customersupportsrc = './images/customer_support_hexamed.png';
		//if(this.props.app.companyid == 3 && this.props.app.companydetails.name !=  'Government of Jammu & Kashmir') customersupportsrc = './images/customer_support_ladakh.png';
		//if(this.props.app.companyid == 4) customersupportsrc = './images/customer_support_chhattisgarh.png';

		//if(this.props.app.companyid == 1 && this.props.app.branch == 'Goa') customersupportsrc = './images/customer_support_goa.png';
		//if(this.props.app.companyid == 1 && this.props.app.branch == 'BMC BLR') customersupportsrc = './images/customer_support_bangalore.png';
		if(this.props.app.companyid == 7) customersupportsrc = './images/customer_support_dmiher_du_wardha.png';
		if(this.props.app.companyid == 8) customersupportsrc = './images/customer_support_aiims_bhopal.png';

		if(this.props.app.isDemoDashboard) customersupportsrc = '';

		return (

			<div className="row">
				<div className="col-lg-12 col-md-12">
					<Loadingcontainer isloading={loaderflag}></Loadingcontainer>
					<div className="row page_title">
						<div className="col-lg-12 col-md-12" >
							<div className="d-flex flex-row justify-content-between margintop-10 marginbottom-10 card-details-header">
								<div>
									<div className="cursor-ptr" style={{color: "#FFFFFF",float: "left"}} onClick={()=>{this.props.history.push('/');}}>
										<div style={{float: "left",width: "25px",height: "25px",background: "#0EC98D",textAlign: "center",borderRadius: "2px 0px 0px 2px"}}>
											<img src="./images/home-btn-icon.svg"/>
										</div>
										<div style={{float: "left",width: "50px",height: "25px",background: "#11E4A1",borderRadius: "0px 2px 2px 0px",fontFamily: "Poppins",fontStyle: "normal",fontWeight: "600",fontSize: "13px",padding: "4px"}}>
											Home
										</div>
									</div>
								</div>
								<div className=" drilldown-header" style={{textAlign:"center",float:"left",fontFamily: "Poppins",fontStyle: "normal",fontSize:"20px"}}>
										Customer Support
								</div>
								<div></div>
							</div>
						</div>
					</div>
					<div className="row no-gutters">
						<div className="col-lg-12 col-md-12" ref="listheader" style={{backgroundColor: '#fff'}}>
							<div className="" ref={this.listbodyRef} style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}>
								<img style={{width: "100%", height: "100%"}} src={customersupportsrc} />
							</div>
							
						</div>
					</div>
				</div>
			</div>
		);
	}
}

CustomerSupport = connect(
	(state, props) => {
		let formName = 'customersupport';

		return {
			app : state.app,
			form : formName
		}
	}, { updateAppState }
)(reduxForm()(CustomerSupport));

export default CustomerSupport;


// WEBPACK FOOTER //
// ./public/react/components/customersupport.js